import React, { useState } from "react";

import styled from "styled-components/macro";

import { AnimatePresence, motion } from "framer-motion";

const variants = {
  unsaved: {
    translateY: 0,
  },

  success: {
    translateY: [0, -7, 2, -4, 1, 0],
    transition: {
      type: "tween",
      duration: 0.5,
    },
  },
  error: {
    rotate: [0, 10, -10, 10, -10, 10, 0],
    transition: { duration: 0.3 },
  },
};

export default function CopyToClipboard({ text, size }) {
  const [animationState, setAnimationState] = useState("unsaved"); // unsaved, success, error
  const [isSaved, setIsSaved] = useState(false);
  const [isError, setIsError] = useState(false);
  const [solidIcon, setSolidIcon] = useState(false);

  async function handleClick() {
    try {
      await navigator.clipboard.writeText(text);
      setAnimationState("success");
      setIsSaved(true);
      setTimeout(() => {
        setSolidIcon(true);
      }, 450);
      setTimeout(() => {
        setIsSaved(false);
        setAnimationState("unsaved");
      }, 2000);
      setTimeout(() => {
        setSolidIcon(false);
      }, 2200);
    } catch (err) {
      console.log(err);
      setAnimationState("error");
      setIsError(true);
      setTimeout(() => {
        setIsError(false);
      }, 2000);
    }
  }

  return (
    <Button size={size} onClick={handleClick}>
      <motion.i
        className={`${solidIcon ? "fas" : "far"} fa-clone`}
        initial="unsaved"
        variants={variants}
        animate={animationState}
        whileTap={{ scale: 0.9 }}
        style={{ paddingLeft: "1px" }}
      ></motion.i>

      <ConfirmationText>
        <AnimatePresence>
          {isSaved ? <RevealingText text="Copied!" /> : null}
          {isError ? <RevealingText text="Try again!" /> : null}
        </AnimatePresence>
      </ConfirmationText>

      {/* {solidIcon ? <ExplodingClone /> : null} */}
    </Button>
  );
}

function RevealingText({ text }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 1 }}
      animate={{
        opacity: 1,
        scale: 1,
        transition: {
          delay: 0.5,
        },
      }}
      exit={{ opacity: 0, scale: 0.5 }}
      transition={{ duration: 0.2 }}
      style={{ fontSize: "12px" }}
    >
      {text}
    </motion.div>
  );
}

function ExplodingClone() {
  return (
    <motion.div
      initial={{ opacity: 0.5, scale: 1 }}
      animate={{
        opacity: [0.5, 0],
        scale: [1, 15],
        filter: ["blur(0px)", "blur(0px)", "blur(3px)"],
      }}
      transition={{ delay: 0.1, duration: 0.3 }}
      style={{ position: "absolute", top: 0, left: 0 }}
    >
      <i className="far fa-clone"></i>
    </motion.div>
  );
}

const Button = styled.button`
  position: relative;
  background: transparent;
  border: none;
  padding: 0;
  font-size: ${(props) => props.size || "inherit"};
  color: ${(props) => props.color || "inherit"};

  &:hover {
    cursor: pointer;
  }
`;

const ConfirmationText = styled(motion.div)`
  position: absolute;
  bottom: -16px;
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  font-size: 14px;
`;
